import {
  LOAD_ONSITE_BOOKING_SLOT,
  LOAD_ONSITE_BOOKING_SLOT_SUCCESS,
  LOAD_ONSITE_BOOKING_SLOT_ERROR,
  HOLD_ONSITE_BOOKING_SLOT,
  HOLD_ONSITE_BOOKING_SLOT_SUCCESS,
  HOLD_ONSITE_BOOKING_SLOT_ERROR,
  RELEASE_ONSITE_BOOKING_SLOT,
  RELEASE_ONSITE_BOOKING_SLOT_SUCCESS,
  RELEASE_ONSITE_BOOKING_SLOT_ERROR,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT_SUCCESS,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT_ERROR,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  RESET_CURRENT_HOLDING_SLOT,
  RESET_SELECTED_ONSITE_BOOKING_SLOT,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

const onsiteBookingPatientReducer = handleActions(
  new Map([
    [
      LOAD_ONSITE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            onsiteBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_ONSITE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            onsiteBookingSlotLoading: { $set: false },
          },
          onsiteBookingData: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_ONSITE_BOOKING_SLOT_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            onsiteBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      HOLD_ONSITE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            onsiteBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      HOLD_ONSITE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            onsiteBookingSlotLoading: { $set: false },
          },
          currentHoldingSlot: { $set: action.payload },
        });
      },
    ],
    [
      RESET_CURRENT_HOLDING_SLOT,
      (state, action) => {
        return update(state, {
          currentHoldingSlot: { $set: {} },
        });
      },
    ],
    [
      HOLD_ONSITE_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            onsiteBookingSlotLoading: { $set: false },
          },
        });
      },
    ],

    //Create patient
    [
      RELEASE_ONSITE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      RELEASE_ONSITE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      RELEASE_ONSITE_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      SAVE_SELECTED_ONSITE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      SAVE_SELECTED_ONSITE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: false },
          },
          selectedBookingSlot: { $set: action.payload },
        });
      },
    ],
    [
      SAVE_SELECTED_ONSITE_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      RESET_SELECTED_ONSITE_BOOKING_SLOT,
      state => {
        return update(state, {
          selectedBookingSlot: { $set: {} },
        });
      },
    ],
    [
      BOOK_APPOINTMENT,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: true },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
          selectedBookingSlot: { $set: action.payload },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default onsiteBookingPatientReducer;
